export default {
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_SERVICEREQUEST (state, serviceRequests) {
    state.serviceRequests = serviceRequests
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex(u => u.id === itemId)
    state.users.splice(userIndex, 1)
  }
}
